<template>
   <v-card @click="goToPage" :style="[toPage ? {'cursor': 'pointer', 'border-radius': '8px'} : {'border-radius': '8px'}]">
      <v-sheet :color="color" class="layout row justify-center corner" elevation="1" style="border-radius: 8px">
         <v-icon color="white">{{icon}}</v-icon>
      </v-sheet>
      <v-card-title>
         <div class="layout column ma-0 justify-space-between pb-1">
            <div class="title">{{title}}</div>
            <p v-if="description" class="description">{{ description }}</p>
         </div>
      </v-card-title>

      <v-card-text class="pt-1">
         <h3 class="headline">{{reachedAmount | fmtFixed}}<span class="caption ml-2">{{caption}}</span></h3>
         <p style="color: #555; margin: 0;" v-if="waitingApproval != null">Aguardando liberação: {{ waitingApproval | fmtMoney }}</p>
         <p style="color: #555;" v-if="waitingConciliation != null">Aguardando conciliação: {{ waitingConciliation | fmtMoney }}</p>
         <v-progress-linear v-if="!hasCancelled && linearStatistic" :color="color" :value="percent * 100" class="mb-1" height="7"></v-progress-linear>
         <p v-if="!linearStatistic" class="user-today-balance-value" style="font-size: 15px;color: #60C232;line-height: 1; margin-top: 14px; margin-bottom: 4px;">+ {{ todayBalance | fmtFixed }} hoje </p>
         <div v-else>
            <div style="width: 100%; height: 7px; display: flex; flex-direction: row; background: #2962ff48; margin-top: 14px; margin-bottom: 4px;">
               <div v-if="(percent * 100).toFixed(1) > 0.1" :style="barStyle"></div>
               <div v-if="(redPercent * 100).toFixed(1) > 0.1" :style="redBarStyle"></div>
            </div>
            <div style="width: 100%; display: flex; flex-direction: row;">
               <span v-if="(percent * 100).toFixed(1) > 0.1" :style="{ width: `${percent * 100}%`, 'max-width': '94.5%', 'min-width': '7%' }" class="caption">{{ percent | fmtPercentP1 }}</span>
               <span v-if="(redPercent * 100).toFixed(1) > 0.1 && ((percent * 100).toFixed(1) >= 7 || (percent * 100).toFixed(1) <= 0.1)" :style="{ width: `${redPercent * 100}%` }" class="caption">{{ redPercent | fmtPercentP1 }}</span>
            </div>
         </div>
         <div v-if="linearStatistic" style="width: 100%; display: flex; justify-content: space-between; flex-direction: row; margin-top: 5px;">
            <span v-if="!hasCancelled" class="caption">{{percent | fmtPercentP1}}</span>
            <div style="display: flex; flex-direction: row; align-items: center;">
               <div style="width: 10px; height: 10px; background-color: #2962ff; margin-right: 2px;"></div>
               <span class="caption" style="margin-right: 10px;">Concluídos</span>
               <div style="width: 10px; height: 10px; background-color: #FF0000; margin-right: 2px;"></div>
               <span class="caption">Rejeitados</span>
            </div>
            <span class="caption font-weight-bold">de {{estimatedAmount | fmtFixed}}</span>
         </div>
      </v-card-text>
   </v-card>
</template>

<script>
   export default {
      props: {
         icon: String,
         title: String,
         reachedAmount: Number,
         cancelledAmount: Number,
         estimatedAmount: Number,
         waitingApproval: Number,
         waitingConciliation: Number,
         caption: String,
         color: String,
         description: String,
         linearStatistic: {
            type: Boolean,
            default: true
         },
         todayBalance: {
            type: Number,
            default: 0
         },
         toPage: String
      },
      computed: {
         percent () {
            let p = 0;
            if (this.estimatedAmount > 0) {
               p = this.reachedAmount / this.estimatedAmount;
            }

            return p;
         },

         hasCancelled() {
            return this.cancelledAmount != null;
         },

         redPercent() {
            let p = 0;
            if (this.estimatedAmount > 0) {
               p = this.cancelledAmount / this.estimatedAmount;
            }

            return p;
         },

         barStyle() {
            return {
               "width": `${this.percent * 100}%`,
               "height": "100%", 
               "background": "#2962ff"
            }
         },

         redBarStyle() {
            return {
               "width": `${(this.cancelledAmount / this.estimatedAmount) * 100}%`,
               "height": "100%", 
               "background": "#ff0000"
            }
         },         
      },
      methods: {
         goToPage() {
            if (this.toPage) {
               this.$router.push(this.toPage);
            }
         }
      }
   };
</script>

<style scoped>
   .corner {
      margin-top: -7px !important;
      margin-right: -7px !important;
      height: 60px;
      width: 95px;
      float: right;
   }

   .description {
      font-size: 15px;
      margin-top: 5px;
      color: #555;
   }
</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/widgets/statistic/CardStatistic.vue